@if (toast) {
  <div
    (mouseenter)="onHoverToast($event)"
    (mouseleave)="onMouseOutToast($event)"
    class="alert alert-success relative overflow-hidden border-none"
    [ngClass]="{
      'alert-success': toast.status === 'success',
      'alert-error': toast.status === 'error',
      'alert-warning': toast.status === 'warning',
      'alert-info': toast.status === 'info',
    }"
  >
    <span>{{ toast.message }}</span>
    <div class="h-6 w-6">
      <!-- <span
        [ngClass]="{
          hidden: isHoveringToast,
        }"
        class="countdown"
      >
        <span id="toastTimer" [style]="counterValue"></span>
      </span> -->
      @if (isHoveringToast) {
        <span>
          <button class="btn btn-square btn-xs" (click)="clearToast()">
            <div class="h-4 w-4 text-base-content">
              <app-close-icon></app-close-icon>
            </div>
          </button>
        </span>
      }
    </div>
    <div
      class="absolute bottom-0 right-0 h-[6px] rounded-full bg-black/50"
      [style.width]="toast.progressPercentage + '%'"
    ></div>
  </div>
}
